import React, { useState, useEffect, useRef } from 'react'
import Autosuggest from 'react-autosuggest';
import {
    InputGroup,
    Input,
} from 'reactstrap';
import { useToggle } from 'utils/common';
import { getProdSuggestions } from 'components/products/product.service';
import { translate } from 'utils/common';
import useProductSearchDisable from 'components/common/productSearch/productSearchDisableHook';
import useOnClickOutside from 'utils/custom-hooks/useOnClickOutside';

export default function ProductAutoSuggest(props) {
    const [autoSuggest, setautoSuggest] = useState();
    const [toggle, setToggle] = useToggle(false);
    const [disableEdit] = useProductSearchDisable(props);
    const ref = useRef();

    useOnClickOutside(ref, () => cancelChanges());
    useEffect(() => {
        setautoSuggest({
            value: props && props.value && props.value.display_name ? props.value.display_name : '',
            suggestions: [],
        })
    }, [props, toggle]);


    function onAutoSuggestInputChange(event, { newValue }) {
        updateValueForAutoSuggest(newValue);
    }

    function updateValueForAutoSuggest(newValue) {
        setautoSuggest((prevValue) => {
            return {
                ...prevValue,
                value: String(newValue)
            }
        });
    }

    const inputProps = {
        onChange: onAutoSuggestInputChange,
        className: 'form-control',
        placeholder: translate('search'),
        autoFocus: true,
        value: autoSuggest && autoSuggest.value
    };

    function onSuggestionsFetchRequested({ value }) {
        const MIN_COUNT = 3;
        if (!value || value.length < MIN_COUNT) {
            return;
        }
        getProdSuggestions(value, props.fullData).then(suggestions => {
            suggestions = suggestions ? suggestions.map((data) => {
                return {
                    sap_product_id: data.source.sap_product_id,
                    id: data.source.o_id,
                    cms_id: data.source.o_id,
                    display_name: data.source.display_name
                }
            }) : [];
            setautoSuggest((prevValue) => {
                return {
                    ...prevValue,
                    suggestions: suggestions
                }
            });
        });
    }

    function onSuggestionsClearRequested() {
        setautoSuggest((prevValue) => {
            return {
                ...prevValue,
                suggestions: []
            }
        });
    }
    function getSuggestionValue(suggestion) {
        return generateDisplayName(suggestion);
    }
    function renderSuggestion(suggestion) {
        return <div>{generateDisplayName(suggestion)}</div>
    }
    function onSuggestionSelected(event, { suggestion }) {
        applyChanges(suggestion);
    }

    function generateDisplayName(model) {
        if (!model || !model.display_name) {
            return '';
        }
        return model.display_name + (model.sap_product_id ? ` ( ${model.sap_product_id} )` : '');
    }

    function applyChanges(suggestion) {
        props.onChange({ target: { name: props.name, value: suggestion ? suggestion : {} } });
        cancelChanges();
    }

    function cancelChanges() {
        updateValueForAutoSuggest('');
        setToggle();
    }


    return (
        <React.Fragment>
            {(!toggle || disableEdit) && <InputGroup>
                <Input type="text" disabled={props.disabled || disableEdit} value={generateDisplayName(props.value)}
                onClick={() => setToggle()} onChange={() => {}}/>
            </InputGroup>}
            {(toggle && !disableEdit) &&
                <React.Fragment>
                    <div className='width-100' ref={ref}>
                        {autoSuggest && (
                            <Autosuggest
                                suggestions={autoSuggest.suggestions}
                                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={onSuggestionsClearRequested}
                                getSuggestionValue={getSuggestionValue}
                                renderSuggestion={renderSuggestion}
                                onSuggestionSelected={onSuggestionSelected}
                                inputProps={inputProps}
                            >
                            </Autosuggest>
                        )}
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    )
}
